module.exports = __webpack_public_path__ + "img/TechTower3_ua.87dd09be.webp";